<script setup lang="ts"></script>

<template>
  <div class="illustration">
    <svg viewBox="0 0 138 97" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M117.509 7.336L118.915 5.495C119.786 4.355 119.568 2.724 118.428 1.853C117.288 .982 115.657 1.2 114.786 2.341L113.38 4.181"
        stroke="currentColor"
        stroke-width="2.639"
      />
      <path
        class="accent"
        d="M2.806 95.839H28.763"
        stroke="currentColor"
        stroke-width="2.135"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.756 63.415C14.736 62.299 16.604 63.16 17.181 65.28C17.728 67.286 17.371 69.22 16.583 71.093C14.699 75.585 11.786 79.412 8.111 82.71C7.566 83.2 7.353 83.614 7.507 84.282C7.661 84.95 7.718 85.713 7.922 86.402C8.276 87.599 8.858 87.879 10.013 87.235C11.173 86.565 12.275 85.808 13.31 84.972C15.269 83.454 17.169 81.854 19.108 80.295C19.312 80.134 19.531 79.989 19.76 79.861C20.557 79.399 21.392 79.009 22.284 79.581C23.215 80.182 23.338 81.149 23.215 82.097C23.038 83.445 22.733 84.78 22.484 86.12L22.775 86.354C23.549 85.747 24.364 85.181 25.088 84.522C26.512 83.222 27.854 81.854 29.288 80.57C30.226 79.729 31.27 78.836 32.694 79.419C34.117 80.002 33.945 81.327 33.951 82.513V85.082L34.236 85.281C35.259 84.31 36.356 83.399 37.291 82.356C38.345 81.181 39.196 79.842 40.254 78.671C40.697 78.181 41.494 77.612 42.045 77.682C42.597 77.751 43.162 78.516 43.473 79.1C43.893 79.889 44.018 80.815 44.367 81.645C45.371 84.03 47.196 84.8 49.623 83.744C51.334 82.999 52.94 82.09 54.472 81.079C54.994 81.831 55.591 82.527 56.251 83.157C54.537 84.294 52.733 85.305 50.854 86.179C46.81 88.052 43.835 86.829 41.868 82.955C41.723 82.665 41.573 82.376 41.36 81.96C40.658 82.764 40.084 83.564 39.362 84.215C38.029 85.42 36.726 86.714 35.196 87.653C33.098 88.941 31.504 88.087 31.256 85.739C31.156 84.779 31.241 83.798 31.241 82.571C30.466 83.271 29.858 83.828 29.241 84.377C27.832 85.63 26.419 86.881 25.002 88.128C24.776 88.319 24.528 88.486 24.264 88.625C23.165 89.221 22.032 89.843 20.788 89.034C19.587 88.254 19.599 87.018 19.719 85.809C19.808 84.92 19.982 84.037 20.173 82.84C19.265 83.592 18.584 84.176 17.88 84.739C16.032 86.227 14.218 87.755 12.313 89.171C11.125 90.055 9.693 90.524 8.167 90.219C5.936 89.774 5.405 87.994 4.948 86.203C4.902 85.95 4.868 85.695 4.848 85.439C3.894 86.014 3.065 86.643 2.123 87.029C1.841 87.13 1.54 87.173 1.24 87.155C.939 87.138 .645 87.059 .378 86.927C.054 86.734-.036 85.978.012 85.494C.044 85.182.467 84.844.791 84.627C2.051 83.775 3.754 83.211 4.505 82.068C5.227 80.965 4.912 79.269 5.168 77.852C5.951 73.526 7.187 69.336 10.009 65.769C10.759 64.824 11.692 64.025 12.756 63.415ZM14.038 65.703C9.795 69.124 8.832 74.007 7.804 78.863L8.111 79.009C8.792 78.165 9.538 77.355 10.174 76.475C12.013 73.929 13.859 71.366 14.533 68.266C14.706 67.476 14.561 66.624 14.561 65.801L14.038 65.703Z"
        fill="currentColor"
      />
      <path
        d="M92.9 28.757L72.286 31.346C71.477 31.679 69.475 33.016 67.934 35.699C63.243 43.864 60.595 52.444 56.09 60.6C55.662 62.574 55.975 66.336 60.656 65.594"
        stroke="currentColor"
        stroke-width="2.639"
      />
      <path
        d="M69.076 55.748C69.076 55.748 71.569 45.474 74.427 44.332C77.285 43.191 80.496 44.332 80.496 44.332"
        stroke="currentColor"
        stroke-width="2.639"
      />
      <path
        d="M100.817 31.396C103.338 33.632 111.131 39.407 118.592 51.325C124.086 60.101 133.766 66.689 137 66.736"
        stroke="currentColor"
        stroke-width="2.639"
      />
      <path
        d="M94.404 59.53C95.498 57.484 98.332 48.312 94.404 46.045L90.694 44.261"
        stroke="currentColor"
        stroke-width="2.639"
      />
      <path
        d="M99.54 59.958C95.14 60.552 84.314 61.028 76.209 58.174C66.077 54.607 61.939 57.675 61.154 63.882C60.369 70.09 80.205 71.017 85.698 74.157C91.192 77.296 91.264 77.225 97.043 81.22C102.823 85.216 112.455 86.714 117.093 86.357C120.803 86.072 124.822 88.902 126.368 90.353"
        stroke="currentColor"
        stroke-width="2.639"
        stroke-linecap="round"
      />
      <path
        d="M63.3 67.164L59.376 78.58L71.79 70.732M80.21 59.316L94.622 40.087L118.025 9.228L111.461 3.948L71.79 56.019"
        stroke="currentColor"
        stroke-width="2.639"
      />
      <path
        d="M72.491 69.401C71.67 71.544 70.973 75.552 73.996 76.787C77.343 78.155 80.151 75.966 81.245 72.684"
        stroke="currentColor"
        stroke-width="2.639"
      />
      <path
        d="M80.922 73.504C80.101 75.647 79.404 79.656 82.426 80.891C85.774 82.259 88.582 80.07 89.676 76.787"
        stroke="currentColor"
        stroke-width="2.639"
      />
      <path
        class="accent"
        d="M113.317 9.622L94.651 33.64"
        stroke="currentColor"
        stroke-width="2.111"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.illustration {
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: rgb(var(--v-theme-on-surface-high-xqes));
    width: 180px;
    height: auto;

    .accent {
      color: rgb(var(--v-theme-brand-accent-xqes));
    }
  }
}
</style>
